import { createFileRoute } from "@tanstack/react-router";
import { PublicFormPage } from "@/features/formpublic/PublicFormPage";

/** Public form for one forms row, found by its slug. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/form/$slug")({
  component: PublicFormRoute,
});

function PublicFormRoute() {
  const { slug } = Route.useParams();
  return <PublicFormPage slug={slug} />;
}
